module.exports = __webpack_public_path__ + "static/media/crouspeyre.2e02724b.jpeg";